<template>
<div>
	<v-dialog
		v-model="dialog"
		width="500"
		class="comment"
	>
		<v-card>
			<v-card-title
					class="headline light-blue darken-1 white--text"
					primary-title
			>
				{{$t('workers.add_comment')}}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout>
						<v-flex md12>
							<v-layout column>
								<v-flex>
									<v-text-field :label="$t('common.text')" v-model="text" />
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="red light-1"
					flat
					@click="cancel"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<v-btn
					color="green light-1"
					flat
					@click="save"
				>
					{{$t('common.save')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-layout d-flex justify-center>
		<v-flex d-flex md2>
			<v-btn
				class="add-comment"
				@click="open"
				color="indigo"
				dark
				md1
			>
				{{$t('workers.add_comment')}}
			</v-btn>
		</v-flex>
	</v-layout>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import { TEMPLATE_PREPAY } from '../../../../constants'
import { notify } from '../../../../utils/notifications'

export default {
	components: {
		ConfirmDialog
	},
	data: () => ({
		dialog: false,
		formData: { ...TEMPLATE_PREPAY },
		text: ''
	}),
	methods: {
		...mapActions({
			createComment: 'workers/createComment',
		}),
		save() {
			const text = this.text
			this.createComment({ text }).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.added', { type: this.$t('common.comment') })
				})
			})
			this.cancel()
		},
		cancel() {
			this.dialog = false
			this.clearForm()
		},
		clearForm() {
			this.text = ''
		},
		open() {
			this.dialog = true
		}
	}
}
</script>
